import { render, staticRenderFns } from "./ItemSection.vue?vue&type=template&id=feb8f53e&"
import script from "./ItemSection.vue?vue&type=script&lang=js&"
export * from "./ItemSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports